import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit"
import { organisationsApi } from "./services"
import { accessApi } from "./services/accessService"
import { modelsApi } from "./services/modelsService"
import { usersApi } from "./services"
import { divisionsApi } from "./services/divisionService"
import { userApi } from "./services/userService"
import { contractsApi } from "./services/contractService"
import { runApi } from "./services/runService"
import { productsApi } from "./services/productsService"
import { graphsApi } from "./services/graphsService"
import { rtkQueryErrorLogger } from "./errorMiddleware"
import { recentActivityApi } from "./services/recentActivityService"
import { baseGraphFamiliesApi } from "./services/baseGraphFamiliesService"
import { documentApi } from "@store/services/documentService"
import { editorApi } from "@store/services/editorService"
import { dashboardApi } from "@store/services/dashboardService"
import { validationApi } from "@store/services/validationService"
import { snapshotApi } from "@store/services/snapshotService"
import { approvalsApi } from "@store/services/approvalsService"
import { authApi } from "@store/services/authService"

export const store = configureStore({
  reducer: {
    [organisationsApi.reducerPath]: organisationsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [divisionsApi.reducerPath]: divisionsApi.reducer,
    [modelsApi.reducerPath]: modelsApi.reducer,
    [accessApi.reducerPath]: accessApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [contractsApi.reducerPath]: contractsApi.reducer,
    [runApi.reducerPath]: runApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [graphsApi.reducerPath]: graphsApi.reducer,
    [recentActivityApi.reducerPath]: recentActivityApi.reducer,
    [baseGraphFamiliesApi.reducerPath]: baseGraphFamiliesApi.reducer,
    [documentApi.reducerPath]: documentApi.reducer,
    [editorApi.reducerPath]: editorApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [validationApi.reducerPath]: validationApi.reducer,
    [snapshotApi.reducerPath]: snapshotApi.reducer,
    [approvalsApi.reducerPath]: approvalsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      organisationsApi.middleware,
      usersApi.middleware,
      divisionsApi.middleware,
      modelsApi.middleware,
      accessApi.middleware,
      userApi.middleware,
      contractsApi.middleware,
      runApi.middleware,
      productsApi.middleware,
      graphsApi.middleware,
      recentActivityApi.middleware,
      baseGraphFamiliesApi.middleware,
      documentApi.middleware,
      editorApi.middleware,
      dashboardApi.middleware,
      validationApi.middleware,
      snapshotApi.middleware,
      approvalsApi.middleware,
      authApi.middleware,
      rtkQueryErrorLogger,
    ),
  devTools: {
    name: "PGM Redux",
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
